import { isUsingWebdriver } from './versionConfig';

//import INITIAL_STATE from './savedStates/addScalebarsToMicroscopyFigure.json';

import INITIAL_STATE from './savedStates/create3in1.json';

//import INITIAL_STATE from './savedStates/createDemoPanels.json';

//import INITIAL_STATE from './savedStates/createMultiColorProjectionAndGreyscale.json';

import createForPoster from './savedStates/createForPoster.json';

import microscopyFigureCreatedForUiEditTest from './savedStates/microscopyFigureCreatedForUiEditTest.json'; 


//import INITIAL_STATE from './savedStates/microscopyFigureCreatedForUiEditTest.json'; 
//import INITIAL_STATE from './savedStates/createFigureWith4ConditionsEachImageMerged.json'; 


//import INITIAL_STATE from './savedStates/rotatedTextCorners.json'; 

//import INITIAL_STATE from './savedStates/chat-discord.json'; 

//import INITIAL_STATE from './savedStates/createAccountAndLogin.json';
//import INITIAL_STATE from './savedStates/statePrep-2images4x1.json'; 
//import INITIAL_STATE from './savedStates/createDemoPanels.json';

//import INITIAL_STATE from './savedStates/prepareVertical4Stack.json';

//import INITIAL_STATE from './savedStates/fs-multiselection.json'; 
//let INITIAL_STATE;


const initialStates = { 
  createForPoster,
  microscopyFigureCreatedForUiEditTest
};


function getInjectedInitialState(){
  let envContainer = (window||process);
  return envContainer.__injectedState;
}

export default function getInitialState(){
  let importedInitialState;
  let injectedInitialState;


  if( typeof(INITIAL_STATE) !== typeof(undefined) ){
    if(false){
      //let INITIAL_STATE;
    }

    function getCookie(name) {
      //copied from stack overflow (https://stackoverflow.com/questions/10730362/get-cookie-by-name)
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }

    if( process.env.NODE_ENV === "development" ){
      if( isUsingWebdriver() ){

        //window.__injectedState;


        if( !window.__testMeta ){
          window.__testMeta = {};
        }

        let agentId = getCookie("agentId");
        let sessionId = getCookie("sessionId");
        let initState = getCookie("initState");

        if( initState && !initialStates[ initState ] ){
          throw Error(`You requested '${initState}' as an initial state, but it hasn't been mapped to inital states dict.`);
        }else if( initState ){
          importedInitialState = initialStates[initState]
        }

        window.__testMeta.agentId = agentId;
        window.__testMeta.sessionId = sessionId;
        window.__testMeta.windowSessionId = sessionId;
        return importedInitialState;
      }else{
        importedInitialState = INITIAL_STATE;  
      }
    }


    return importedInitialState;
  }


  injectedInitialState = getInjectedInitialState();

  return injectedInitialState || importedInitialState;



}
